import React from "react";

const LandingFrame: React.FC = () => {
    return (
        <div style={{ position: "fixed", inset: 0, width: "100vw", height: "100vh", overflow: "hidden" }}>
            <iframe
                src="/prediction_landing.html"
                title="Prediction"
                style={{ width: "100%", height: "100%", border: "none", display: "block" }}
            />
        </div>
    );
};

export default LandingFrame;
